var map = {
	"./arrow-diagonal.svg": 74345,
	"./arrow-side.svg": 11277,
	"./cross.svg": 24416,
	"./menu.svg": 99661,
	"./minus.svg": 48320,
	"./pause.svg": 46198,
	"./play.svg": 46934,
	"./plus.svg": 90824,
	"./slash-back.svg": 89341,
	"./slash-forward.svg": 56931,
	"./square.svg": 88069,
	"./status-error.svg": 57755,
	"./status-information.svg": 86111,
	"./status-warning.svg": 22125,
	"./volume.svg": 59574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14680;